import { createBrowserRouter, Navigate } from "react-router-dom";

import RouteError from "@/components/RouteError";
import AuthWrapper from "@/components/wrappers/AuthWrapper";
import UserWrapper from "@/components/wrappers/UserWrapper";
import CreateCustomJobForQuote from "@/pages/admin/CreateCustomJobForQuote";
import CreateUpdateQuote from "@/pages/admin/CreateUpdateQuote";
import CreateUpdateJob from "@/pages/admin/compositeJob/CreateUpdateJob";
import Dashboard from "@/pages/admin/Dashboard";
import DraftEditJob from "@/pages/admin/DraftEditJob";
import Job from "@/pages/admin/Job";
import Jobs from "@/pages/admin/Jobs";
import CreateUpdateMechanicalJob from "@/pages/admin/mechanicalJob/CreateUpdateMechanicalJob";
import Organization from "@/pages/admin/Organization";
import Profile from "@/pages/admin/Profile";
import Quote from "@/pages/admin/Quote";
import Quotes from "@/pages/admin/Quotes";
import ForgotPassword from "@/pages/guest/ForgotPassword";
import Login from "@/pages/guest/Login";
import SetNewPassword from "@/pages/guest/SetNewPassword";
import Signup from "@/pages/guest/Signup";
import RepairIntakeForm from "@/pages/public/RepairIntakeForm";

const guestRoutes = [
  {
    path: "/login",
    errorElement: <RouteError />,
    element: (
      <AuthWrapper withRightBlock>
        <Login />
      </AuthWrapper>
    ),
  },
  {
    path: "/forgot-password",
    errorElement: <RouteError />,
    element: (
      <AuthWrapper>
        <ForgotPassword />
      </AuthWrapper>
    ),
  },
  {
    path: "/set-new-password",
    errorElement: <RouteError />,
    element: (
      <AuthWrapper>
        <SetNewPassword />
      </AuthWrapper>
    ),
  },
  {
    path: "/signup",
    errorElement: <RouteError />,
    element: (
      <AuthWrapper withRightBlock>
        <Signup />
      </AuthWrapper>
    ),
  },
  {
    path: "/repair-intake",
    errorElement: <RouteError />,
    element: <RepairIntakeForm />,
  },
];

const adminRoutes = [
  {
    path: "/",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <Jobs />
      </UserWrapper>
    ),
  },
  {
    path: "/quotes",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <Quotes />
      </UserWrapper>
    ),
  },

  {
    path: "/quotes/create",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <CreateUpdateQuote />
      </UserWrapper>
    ),
  },
  {
    path: "/quotes/create-edit-custom-quote",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <CreateCustomJobForQuote />
      </UserWrapper>
    ),
  },
  {
    path: "/quotes/:id",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <Quote />
      </UserWrapper>
    ),
  },
  {
    path: "/jobs/create/mechanical",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <CreateUpdateMechanicalJob />
      </UserWrapper>
    ),
  },
  {
    path: "/jobs/create/composite",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <CreateUpdateJob />
      </UserWrapper>
    ),
  },
  {
    path: "/jobs/:id",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <Job />
      </UserWrapper>
    ),
  },
  {
    path: "/jobs/:id/draft-edit",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <DraftEditJob />
      </UserWrapper>
    ),
  },
  {
    path: "/personal-information",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <Profile />
      </UserWrapper>
    ),
  },
  {
    path: "/company-information",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <Organization />
      </UserWrapper>
    ),
  },
  {
    path: "/dashboard",
    errorElement: <RouteError />,
    element: (
      <UserWrapper>
        <Dashboard />
      </UserWrapper>
    ),
  },
];

const router = createBrowserRouter([
  ...guestRoutes,
  ...adminRoutes,
  {
    path: "*",
    element: <Navigate to="/" />,
  },
]);
export default router;
